import * as Actions from './types';

const initState = {
  init: false,
  model: {
    id: null,
    code: '',
    name: '',
    created_at: null,
    updated_at: null,
  },
};

const QuestionView = (state = initState, action) => {
  switch (action.type) {
    case Actions.FETCH_ONE:
      return {
        ...state,
        init: true,
        model: action.model,
      };
    case Actions.CLEAR_ONE:
      return {
        ...initState,
      };
    default:
      return state;
  }
};
export default QuestionView;
